// extracted by css-extract-rspack-plugin
export default {"cls1":"CollapsedActivityPreview-cls1_mOH","cls2":"CollapsedActivityPreview-cls2_3Zb CollapsedActivityPreview-cls1_mOH"};